import type GetPopOverVerticalOffset from './types';

const getPopOverVerticalOffset: GetPopOverVerticalOffset = (
  vertical: number,
) => ({vertical});

export default getPopOverVerticalOffset;
